import { useCallback, useRef, useState } from 'react';
import Modal from 'src/Utils/CssModules/modal.module.css';
import useOutsideClick from 'src/Utils/Hooks/UseOutSideClick/UseOutSideClick';
import './PopupDialog.css'
export interface IPopupDialogParams{
    children: React.ReactNode,
    onClose: () => void,
    popupWidth?: string
}
const PopupDialog:React.FC<IPopupDialogParams> = ({children, onClose, popupWidth}) => {
    // 'flex' rather than 'block': the inline style wins over Modal.centered,
    // which needs the overlay to be a flex container to centre the dialog.
    const [display, setdisplay] = useState('flex');
    const wrapperRef = useRef<HTMLDivElement>(null);
    useOutsideClick(wrapperRef, () => { close()})
    const close = useCallback(() => {
        setdisplay('none');
        onClose();
    }, [onClose]);
    return(
        <>
          <div className='row '>
            <div id="myModal" className={`${Modal.modal} ${Modal.centered}`} style={{ display: display, zIndex: 1001 }}>
                <div className={`${Modal.content} content`} ref={wrapperRef} style={{width: popupWidth}}>
                    {children}
                </div>
            </div>
         </div>
        </>
    )
}
export default PopupDialog